export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

const mimeTypeToExtension: Record<string, string> = {
  'application/pdf': 'PDF',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'DOCX',
  'application/vnd.ms-excel': 'XLS',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
  'application/vnd.ms-powerpoint': 'PPT',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'PPTX',
  'text/plain': 'TXT',
  'text/csv': 'CSV',
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/gif': 'GIF',
  'image/webp': 'WEBP',
  'application/zip': 'ZIP',
  'application/x-rar-compressed': 'RAR',
  'application/x-7z-compressed': '7Z',
};

export const getFileExtension = (
  mimeTypeOrFormat: string | undefined,
  fileName?: string
): string => {
  if (!mimeTypeOrFormat && !fileName) return '';

  if (mimeTypeOrFormat && mimeTypeToExtension[mimeTypeOrFormat]) {
    return mimeTypeToExtension[mimeTypeOrFormat];
  }

  if (fileName && fileName.includes('.')) {
    return fileName.split('.').pop()?.toUpperCase() || '';
  }

  if (mimeTypeOrFormat && mimeTypeOrFormat.includes('/')) {
    const subtype = mimeTypeOrFormat.split('/')[1];
    if (subtype) {
      const cleanSubtype = subtype.split(';')[0].split('+')[0];
      return cleanSubtype.toUpperCase();
    }
  }

  return mimeTypeOrFormat?.toUpperCase() || '';
};
